module.exports = __webpack_public_path__ + "static/media/skydrone.1a9cf78a.glb";